export const DEFAULT_META = {
  icon: '/favicon.ico',
  appleTouchIcon: '/logo192.png',
  manifest: '/manifest.json',
}
export type Meta = typeof DEFAULT_META
